export const EventType = {
  EVENT: 'event',
  CONFIG: 'config',
};

export const EventAction = {
  //SIGNUP/LOGIN
  OL_LOGIN_SIGNUP_SIGNUP: 'ol_loginSignup_signup',
  OL_LOGIN_SIGNUP_LOGIN: 'ol_loginSignup_login',
  OL_LOGIN_SIGNUP_PASSWORD: 'ol_loginSignup_password',
  OL_LOGIN_SIGNUP_CONFIRM_PASSWORD: 'ol_loginSignup_confirmPassword',
  OL_LOGIN_SIGNUP_INCORRECT_PHONENO_ERROR: 'ol_loginSignup_incorrectPhoneNoError',
  OL_LOGIN_SIGNUP_SIGNUPVERIFICATION_CODE: 'ol_loginSignup_signupVerificationCode',
  OL_LOGIN_SIGNUP_SIGNUP_RESEND: 'ol_loginSignup_signupResend',
  OL_LOGIN_SIGNUP_SIGNUP_DETAILS_NEXT: 'ol_loginSignup_signupDetailsNext',
  OL_LOGIN_SIGNUP_SIGNUP_FIRSTNAME: 'ol_loginSignup_signupFirstName',
  OL_LOGIN_SIGNUP_SIGNUP_LASTNAME: 'ol_loginSignup_signupLastName',
  OL_LOGIN_SIGNUP_SIGNUP_INCORRECT_FIRSTNAME_ERROR: 'ol_loginSignup_signupIncorrectFirstNameError',
  OL_LOGIN_SIGNUP_SIGNUP_INCORRECT_LASTNAME_ERROR: 'ol_loginSignup_signupIncorrectLastNameError',
  OL_LOGIN_SIGNUP_SIGNUP_INCORRECT_NAME: 'ol_loginSignup_signupIncorrectName',
  OL_LOGIN_SIGNUP_SIGNUP_INCORRECT_EMAIL_ERROR: 'ol_loginSignup_signupIncorrectEmailError',
  OL_LOGIN_SIGNUP_SAVE_PASSWORD: 'ol_loginSignup_savePassword',
  OL_LOGIN_SIGNUP_SIGNUP_DOB: 'ol_loginSignup_signupDob',
  OL_LOGIN_SIGNUP_SIGNUP_DOB_OKAY: 'ol_loginSignup_signupDobOkay',
  OL_LOGIN_SIGNUP_PASSWORD_SKIP: 'ol_loginSignup_passwordSkip',
  OL_LOGIN_SIGNUP_LOGIN_TO_ACCOUNT: 'ol_loginSignup_loginToAccount',
  OL_LOGIN_SIGNUP_USE_ANOTHER_NUMBER: 'ol_loginSignup_useAnotherNumber',
  OL_LOGIN_SIGNUP_LETS_GO: 'ol_loginSignup_letsGo',
  OL_LOGIN_SIGNUP_LOGIN_PHONE_NEXT: 'ol_loginSignup_loginPhoneNext',
  OL_LOGIN_SIGNUP_LOGIN_VERIFICATION_CODE: 'ol_loginSignup_loginVerificationCode',
  OL_LOGIN_SIGNUP_FORGOT_PASSWORD_VERIFICATION_CODE: 'ol_loginSignup_forgotPasswordVerificationCode',
  OL_LOGIN_SIGNUP_LOGIN_RESEND: 'ol_loginSignup_loginResend',
  OL_LOGIN_SIGNUP_LOGIN_SAVE_PASSWORD: 'ol_loginSignup_loginSavePassword',
  OL_LOGIN_SIGNUP_LOGIN_PASSWORD_SKIP: 'ol_loginSignup_loginPasswordSkip',
  OL_LOGIN_SIGNUP_FORGOT_PASSWORD: 'ol_loginSignup_forgotPassword',
  OL_LOGIN_SIGNUP_LOGIN_WITH_VERIFICATION_CODE: 'ol_loginSignup_loginWithVerificationCode',
  OL_LOGIN_SIGNUP_LOGIN_SIGNUP: 'ol_loginSignup_loginSignup',
  OL_LOGIN_SIGNUP_LOGIN_PASSWORD: 'ol_loginSignup_loginPassword',
  OL_LOGIN_SIGNUP_FORGOTPASSWORD_PASSWORD: 'ol_loginSignup_forgotPasswordPassword',
  OL_LOGIN_SIGNUP_LOGIN_INCORRECT_PHONENO_ERROR: 'ol_loginSignup_loginIncorrectPhonenoError',
  OL_LOGIN_SIGNUP_NAVBAR_LOGIN: 'ol_loginSignup_navbarLogin',
  OL_LOGIN_SIGNUP_NAVBAR_SIGNUP: 'ol_loginSignup_navbarSignup',
  OL_LOGIN_SIGNUP_SIGNOUT: 'ol_loginsignup_signout',
  OL_LOGINSIGNUP_SIGNPHONENEXT: 'ol_loginSignup_signupPhoneNext',
  //RESTAURANT PAGE
  OL_REST_PAGE_PICKUP: 'ol_restPage_pickup',
  OL_REST_PAGE_DELIVERY: 'ol_restPage_delivery',
  OL_REST_PAGE_VIEW_HOURS: 'ol_restPage_viewHours',
  OL_REST_PAGE_EDIT_ADDRESS_TYPE: 'ol_restPage_editAddressType',
  OL_REST_PAGE_CALENDAR: 'ol_restPage_calendar',
  OL_REST_PAGE_FIND_NEAREST_LOCATION: 'ol_restPage_findNearestLocation',
  OL_REST_PAGE_ADDRESS_NEXT: 'ol_restPage_addressNext',
  OL_REST_PAGE_ORDER_TYPE_NEXT: 'ol_restPage_orderTypeNext',
  OL_REST_PAGE_ORDER_TYPE_BACK: 'ol_restPage_orderTypeBack',
  OL_REST_PAGE_RESTPAGE_BACK: 'ol_restPage_restPageBack',
  OL_REST_PAGE_DATETIME_BACK: 'ol_restPage_dateTimeBack',
  OL_REST_PAGE_ADDRESS: 'ol_restPage_address',
  OL_REST_PAGE_APARTMENT_ADDRESS: 'ol_restPage_apartmentAddress',
  OL_REST_PAGE_CONFIRM_PICKUP: 'ol_restPage_confirmPickup',
  OL_REST_PAGE_CONFIRM_DELIVERY: 'ol_restPage_confirmDelivery',
  OL_REST_PAGE_ORDER_TYPE_PICKUP: 'ol_restPage_orderTypePickup',
  OL_REST_PAGE_ORDER_TYPE_DELIVERY: 'ol_restPage_orderTypeDelivery',
  OL_REST_PAGE_BOOKMARK: 'ol_restPage_bookmark',
  OL_REST_PAGE_REVIEWS: 'ol_restPage_reviews',
  OL_REST_PAGE_VIEW_CART: 'ol_restPage_viewCart',
  OL_REST_PAGE_REST_PAGE_DELIVERY: 'ol_restPage_restPageDelivery',
  OL_REST_PAGE_MENU_DROP_DOWN: 'ol_restPage_menuDropdown',
  OL_REST_PAGE_REVIEWS_BACK: 'ol_restPage_reviewsBack',
  OL_REST_PAGE_VIEW_MENU: 'ol_restPage_viewMenu',
  //CART
  OL_CART_PLUS: 'ol_cart_plus',
  OL_CART_MINUS: 'ol_cart_minus',
  OL_CART_DELETE: 'ol_cart_delete',
  OL_CART_CROSS: 'ol_cart_cross',
  OL_CART_ADD_MORE: 'ol_cart_addMore',
  OL_CART_CHECKOUT: 'ol_cart_checkout',
  OL_CART_CHECKOUT_AS_GUEST: 'ol_checkout_checkoutAsGuest',
  OL_CART_PEOPLE_ALSO_ORDERED: 'ol_cart_peopleAlsoOrdered',
  OL_ADD_TO_CART_PLUS: 'ol_add_cart_plus',
  OL_PREPARE_CART: 'ol_prepare_cart',

  //checkout
  OL_CHECKOUT_LOGIN: 'ol_checkout_login',
  OL_CHECKOUT_CREATE_MY_ACCOUNT: 'ol_checkout_createMyAccount',
  OL_CHECKOUT_CROSS_LOGIN_POPUP: 'ol_checkout_crossLoginPopup',
  OL_CHECKOUT_REVIEW_ORDER_BACK: 'ol_checkout_reviewOrderBack',
  OL_CHECKOUT_PAYMENTTYPE_BACK: 'ol_checkout_paymentTypeBack',
  OL_CHECKOUT_ORDER_TYPE_BACK: 'ol_checkout_orderTypeBack',
  OL_CHECKOUT_PROCEED_TO_PAYMENT: 'ol_checkout_proceedToPayment',
  OL_CHECKOUT_PAYBY_CARD: 'ol_checkout_paybyCard',
  OL_CHECKOUT_EDIT: 'ol_checkout_edit',
  OL_CHECKOUT_ORDER_TYPE_NEXT: 'ol_checkout_orderTypeNext',
  OL_CHECKOUT_SIGNUPVERIFICATIONCCODE: 'ol_checkout_signUpVerificationCode',
  OL_CHECKOUT_PAYMENTSUCCESSFULL: 'ol_checkout_paymentsuccessful',
  OL_CHECKOUT_PAYMENTUNSUCCESSFULL: 'ol_checkout_paymentunsuccessful',
  OL_CHECKOUT_DEALSBANNERTAPPED: 'ol_checkout_dealsBannerTapped',

  //my account
  OL_MYACCOUNT_PERSONALINFO_SAVE: 'ol_myAccount_personalInfoSave',
  OL_MYACCOUNT_ADD_EMAIL: 'ol_myAccount_addEmail',
  OL_MYACCOUNT_MARKETING_SIGNUP_TAPPED: 'marketing_signup_tapped',
  OL_MYACCOUNT_MARKETING_SIGNUP: 'ol_myAccount_marketingSignup',
  OL_MYACCOUNT_ADD_EMAIL_RESEND: 'ol_myAccount_addEmailResend',
  OL_MYACCOUNT_PERSONALINFO_CHANGES_SAVED: 'ol_myAccount_personalInfoChangesSaved',
  OL_MYACCOUNT_FIRSTNAME: 'ol_myAccount_firstName',
  OL_MYACCOUNT_TAPPED: 'ol_myAccount_tapped',
  OL_MYACCOUNT_PERSONAL_INFO: 'ol_myAccount_personalInfo',
  OL_MYACCOUNT_PERSONAL_INFOEMAIL_ADDED: 'ol_myAccount_personalInfoEmailAdded',
  OL_MYACCOUNT_ADD_EMAIL_NEXT: 'ol_myAccount_addEmailNext',

  //MY Orders
  OL_MY_ORDERS_TAPPED: 'ol_myOrders_tapped',
  OL_MY_ORDERS_REORDER_ADDMORE_ITEMS: 'ol_myOrders_reorderAddMoreItems',
  OL_MY_ORDERS_REORDER_ADD_TO_CART: 'ol_myOrders_reorderAddToCart',
  OL_MY_ORDERS_REORDER_CROSS: 'ol_myOrders_reorderCross',
  OL_MY_ORDERS_TRACK_ORDER: 'ol_myOrders_trackOrder',
  OL_MY_ORDERS_REORDER: 'ol_myOrders_reorder',
  OL_MY_ORDERS_TRACK_ORDER_DETAILS: 'ol_myOrders_trackOrderDetails',
  OL_MY_ORDERS_BACK: 'ol_myOrders_Back',
  OL_MY_ORDERS_SEEMENU: 'ol_myOrders_seeMenu',

  //Menu Item
  OL_MENU_ITEM_PLUS: 'ol_menuItem_plus',
  OL_MENU_ITEM_MINUS: 'ol_menuItem_minus',
  OL_MENU_ITEM_ITEM_REVIEWS: 'ol_menuItem_Itemreviews',
  OL_MENU_ITEM_BACK: 'ol_menuItem_Back',
  OL_MENU_ITEM_ADD_TO_CART: 'ol_menuItem_addtoCart',
  OL_MENU_ITEM_BOOKMARK: 'ol_menuItem_bookmark',
  OL_MENU_ITEM_REQUIRED: 'ol_menuItem_required',
  OL_MENU_ITEM_TAB_POSITION: 'ol_menuItem_tabPosition',
  OL_MENU_ITEM_CUSTOMIZE: 'ol_menuItem_customize',
  OL_MENU_ITEM_ADD_ONS: 'ol_menuItem_addOns',
  OL_MENU_ITEM_SPECIAL_REQUEST: 'ol_menuItem_specialRequests',

  // post ordering

  OL_POST_ORDERING_VIEW: 'ol_postOrdering_view',
  OL_POST_ORDERING_CROSS: 'ol_postOrdering_cross',
  OL_POST_ORDERING_GET_DIRECTIONS: 'ol_postOrdering_getDirections',
  OL_POST_ORDERING_REST_NUMBER: 'ol_postOrdering_restNumber',
  OL_POST_ORDERING_STAR: 'ol_postOrdering_star',
  OL_POST_ORDERING_REVIEW_CROSS: 'ol_postOrdering_reviewCross',
  OL_POST_ORDERING_ITEM_REVIEW: 'ol_postOrdering_itemReview',
  OL_POST_ORDERING_ITEM_LIKE: 'ol_postOrdering_itemLike',
  OL_POST_ORDERING_POST_REVIEW: 'ol_postOrdering_postReview',
  OL_POST_ORDERING_DONE_REVIEW_SUCCESSFUL: 'ol_postOrdering_doneReviewSuccessful',
  OL_POST_ORDERING_DONE_REVIEW_UNSUCCESSFUL: 'ol_postOrdering_doneReviewUnSuccessful',
  OL_POST_ORDERING_CROSS_REVIEW_SUCCESSFUL: 'ol_postOrdering_crossReviewSuccessful',
  OL_POST_ORDERING_CROSS_REVIEW_UNSUCCESSFUL: 'ol_postOrdering_crossReviewUnSuccessful',

  // loyalty events for online
  QL_RESTAURANTPAGE_REDEEMNOW: 'OL_restaurantPage_redeemNow',
  OL_CART_REDEEMNOW: 'ol_cart_redeemNow',
  OL_RESTAURANTPAGE_VIEWDETAILS: 'ol_restaurantPage_viewDetails',
  OL_CART_VIEWDETAILS: 'ol_cart_viewDetails',
  OL_REWARDS_LOGIN: 'ol_rewards_login',
  OL_REWARDS_SIGNUP: 'ol_rewards_signUp',
  OL_REWARDS_CARTLOGIN: 'ol_rewards_cartLogin',
  OL_REWARDS_CARTSIGNUP: 'ol_rewards_cartSignUp',
  OL_POSTORDERING_LOGIN: 'ol_postOrdering_login',
  OL_POSTORDERING_SIGNUP: 'ol_postOrdering_signup',

  // DEALS EVENTS for Online

  OL_RESTPAGE_DEALSTAPPED: 'ol_restPage_dealsTapped',
  OL_DEALS_UNLOCKDEALS: 'ol_deals_unlockDeals',

  ADYEN_TRANSACTION_TIMEOUT: 'ol_checkout_paymentUnsuccessfulTransactionTimeOut',
  ADYEN_PAYMENT_UNSUCCESSFUL: 'ol_checkout_paymentUnsuccessfulGeneralError',
};

export const QREventActions = {
  // Initial Screen done
  QR_INITIALSCREEN_OPENED: 'qr_initialScreen_opened',
  QR_INITIALSCREEN_STARTORDERING: 'qr_initialScreen_startOrdering',
  QR_INITIALSCREEN_PRIVACYPOLICY: 'qr_initialScreen_privacyPolicy',
  QR_INITIALSCREEN_CREATEMYACCOUNT: 'qr_initialScreen_createMyAccount',
  QR_CHECKOUT_SIGNUPVERIFICATIONCODE: 'qr_checkout_signUpVerificationCode',

  // Cart done
  QR_CART_CROSS: 'qr_cart_cross',
  QR_CART_ADDMORE: 'qr_cart_addMore',
  QR_CART_CHECKOUT: 'qr_cart_checkout',
  QR_CART_PLUS: 'qr_cart_plus',
  QR_CART_MINUS: 'qr_cart_minus',
  QR_CART_DELETE: 'qr_cart_delete',
  QR_CART_PEOPLEALSOORDERED: 'qr_cart_peopleAlsoOrdered',
  QR_CART_EMPTYCART: 'qr_cart_emptyCart',
  QR_CART_EMPTYCARTCROSS: 'qr_cart_emptyCartCross',
  QR_CART_ADDITEMS: 'qr_cart_addItems',
  QR_CART_REMOVEITEMOUTOFSTOCK: 'qr_cart_removeItemOutOfStock',
  QR_CART_REMOVEMODIFIEROUTOFSTOCK: 'qr_cart_removeModifierOutOfStock',
  QR_CART_REMOVEITEMUNAVAILABLE: 'qr_cart_removeItemUnavailable',

  // Checkout done
  QR_CHECKOUT_PAYNOW: 'qr_checkout_payNow',
  QR_CHECKOUT_PAYMENTTYPEBACK: 'qr_checkout_paymentTypeBack',
  QR_CHECKOUT_APPLEPAY: 'qr_checkout_applePay',
  QR_CHECKOUT_GOOGLEPAY: 'qr_checkout_googlePay',
  QR_CHECKOUT_PAYBYCARD: 'qr_checkout_paybyCard',
  QR_CHECKOUT_ITEMUNAVAILABLEBACKCART: 'qr_checkout_itemUnavailableBackCart',
  QR_CHECKOUT_ITEMUNAVAILABLECROSS: 'qr_checkout_itemUnavailableCross',
  QR_CHECKOUT_ORDERUNAVAILABLECROSS: 'qr_checkout_orderUnavailableCross',
  QR_CHECKOUT_ORDERUNAVAILABLECHANGETIME: 'qr_checkout_orderUnavailableChangeTime',
  QR_CHECKOUT_OUTOFSTOCKCROSS: 'qr_checkout_outOfStockCross',
  QR_CHECKOUT_OUTOFSTOCKBACKCART: 'qr_checkout_outOfStockBackCart',
  QR_CHECKOUT_RESTCLOSEDFULLCROSS: 'qr_checkout_restClosedFullCross',
  QR_CHECKOUT_RESTCLOSEDFULLBACKTOMENU: 'qr_checkout_restClosedFullBackToMenu',
  QR_CHECKOUT_PAYMENTSUCCESSFULL: 'qr_checkout_paymentsuccessful',
  QR_CHECKOUT_PAYMENTUNSUCCESSFULL: 'qr_checkout_paymentunsuccessful',
  QR_CHECKOUT_PROCEED_TO_PAYMENT: 'qr_checkout_proceedToPayment',
  QR_CHECKOUT_DEALSBANNERTAPPED: 'qr_checkout_dealsBannerTapped',

  // Menu Item done
  QR_MENUITEM_PLUS: 'qr_menuItem_plus',
  QR_MENUITEM_MINUS: 'qr_menuItem_minus',
  QR_MENUITEM_ADDTOCART: 'qr_menuItem_addtoCart',
  QR_MENUITEM_REQUIRED: 'qr_menuItem_required',
  QR_MENUITEM_CUSTOMIZE: 'qr_menuItem_customize',
  QR_MENUITEM_ADDONS: 'qr_menuItem_addOns',
  QR_MENUITEM_SPECIALREQUESTS: 'qr_menuItem_specialRequests',
  QR_MENUITEM_TABPOSITION: 'qr_menuItem_tabPosition',
  QR_MENUITEM_BACK: 'qr_menuItem_Back',
  QR_MENUITEM_ITEMREVIEWS: 'qr_menuItem_Itemreviews',
  QR_MENUITEM_ALLERGENADDTOCART: 'qr_menuItem_allergenAddToCart',
  QR_MENUITEM_ALLERGENNO: 'qr_menuItem_allergenNo',
  QR_MENUITEM_ALLERGENCROSS: 'qr_menuItem_allergenCross',
  QR_MENUITEM_BOOKMARK: 'qr_menuItem_bookmark',
  QR_MENUITEM_OUTOFSTOCKGOBACK: 'qr_menuItem_outOfStockGoBack',

  // Restaurant Page done
  QR_RESTPAGE_RESTPAGEBACK: 'qr_restPage_restPageBack',
  QR_RESTPAGE_BOOKMARK: 'qr_restPage_bookmark',
  QR_RESTPAGE_IICON: 'qr_restPage_iIcon',
  QR_RESTPAGE_VIEW: 'qr_restPage_view',
  QR_RESTPAGE_REVIEWS: 'qr_restPage_reviews',
  QR_RESTPAGE_VIEWCART: 'qr_restPage_viewCart',
  QR_RESTPAGE_MENUDROPDOWN: 'qr_restPage_menuDropdown',
  QR_RESTPAGE_REVIEWSBACK: 'qr_restPage_reviewsBack',
  QR_RESTPAGE_MAP: 'qr_restPage_map',
  QR_RESTPAGE_RESTPAGEVIEWHOURS: 'qr_restPage_restPageViewHours',
  QR_RESTPAGE_PHONENO: 'qr_restPage_phoneNo',
  QR_RESTPAGE_MOREINFOREVIEWS: 'qr_restpage_moreInfoReviews',
  QR_RESTPAGE_VIEWMORELOCATIONS: 'qr_restpage_viewMoreLocations',
  QR_RESTPAGE_SEARCH: 'qr_restPage_search',
  QR_RESTPAGE_APPLY: 'qr_restPage_apply',
  QR_RESTPAGE_CLEAR: 'qr_restPage_clear',
  QR_RESTPAGE_ITEM: 'qr_restPage_item',

  // Login/Sign Up
  QR_LOGINSIGNUP_NAVBARLOGIN: 'qr_loginSignup_navbarLogin',
  QR_LOGINSIGNUP_NAVBARSIGNUP: 'qr_loginSignup_navbarSignup',
  QR_LOGINSIGNUP_SIGNUP: 'qr_loginSignup_signup',
  QR_LOGINSIGNUP_LOGIN: 'qr_loginSignup_login',
  QR_LOGINSIGNUP_INCORRECTPHONENOERROR: 'qr_loginSignup_incorrectPhoneNoError',
  QR_LOGINSIGNUP_SIGNUPPHONENEXT: 'qr_loginSignup_signupPhoneNext',
  QR_LOGINSIGNUP_LOGINTOACCOUNT: 'qr_loginSignup_loginToAccount',
  QR_LOGINSIGNUP_USEANOTHERNUMBER: 'qr_loginSignup_useAnotherNumber',
  QR_LOGINSIGNUP_SIGNUPVERIFICATIONCODE: 'qr_loginSignup_signupVerificationCode',
  QR_LOGINSIGNUP_SIGNUPRESEND: 'qr_loginSignup_signupResend',
  QR_LOGINSIGNUP_SIGNUPINCORRECTFIRSTNAMEERROR: 'qr_loginSignup_signupIncorrectFirstNameError',
  QR_LOGINSIGNUP_SIGNUPINCORRECTLASTNAMEERROR: 'qr_loginSignup_signupIncorrectLastNameError',
  QR_LOGINSIGNUP_SIGNUPINCORRECTEMAILERROR: 'qr_loginSignup_signupIncorrectEmailError',
  QR_LOGINSIGNUP_SIGNUPDETAILSNEXT: 'qr_loginSignup_signupDetailsNext',
  QR_LOGINSIGNUP_SIGNUPFIRSTNAME: 'qr_loginSignup_signupFirstName',
  QR_LOGINSIGNUP_SIGNUPLASTNAME: 'qr_loginSignup_signupLastName',
  QR_LOGINSIGNUP_SIGNUPDOB: 'qr_loginSignup_signupDob',
  QR_LOGINSIGNUP_SIGNUPDOBOKAY: 'qr_loginSignup_signupDobOkay',
  QR_LOGINSIGNUP_PASSWORDSKIP: 'qr_loginSignup_passwordSkip',
  QR_LOGINSIGNUP_SAVEPASSWORD: 'qr_loginSignup_savePassword',
  QR_LOGINSIGNUP_PASSWORD: 'qr_loginSignup_password',
  QR_LOGINSIGNUP_CONFIRMPASSWORD: 'qr_loginSignup_confirmpassword',
  QR_LOGINSIGNUP_LETSGO: 'qr_loginSignup_letsGo',
  QR_LOGINSIGNUP_LOGINSIGNUP: 'qr_loginSignup_loginSignup',
  QR_LOGINSIGNUP_LOGINPHONENO: 'qr_loginSignup_loginPhoneno',
  QR_LOGINSIGNUP_LOGINPHONENEXT: 'qr_loginSignup_loginPhoneNext',
  QR_LOGINSIGNUP_LOGININCORRECTPHONENOERROR: 'qr_loginSignup_loginIncorrectPhonenoError',
  QR_LOGINSIGNUP_LOGINPASSWORD: 'qr_loginSignup_loginPassword',
  QR_LOGINSIGNUP_FORGOTPASSWORD: 'qr_loginSignup_forgotPassword',
  QR_LOGINSIGNUP_LOGINWITHVERIFICATIONCODE: 'qr_loginSignup_loginWithVerificationCode',
  QR_LOGINSIGNUP_SIGNUPTOACCOUNT: 'qr_loginSignup_signupToAccount',
  QR_LOGINSIGNUP_LOGINUSEANOTHERNUMBER: 'qr_loginSignup_loginUseAnotherNumber',
  QR_LOGINSIGNUP_LOGINVERIFICATIONCODE: 'qr_loginSignup_loginVerificationCode',
  QR_LOGINSIGNUP_LOGINRESEND: 'qr_loginSignup_loginResend',
  QR_LOGINSIGNUP_LOGINPASSWORDSKIP: 'qr_loginSignup_loginPasswordSkip',
  QR_LOGINSIGNUP_LOGINSAVEPASSWORD: 'qr_loginSignup_loginSavePassword',
  QR_LOGINSIGNUP_FORGOTPASSWORDVERIFICATIONCODE: 'qr_loginSignup_forgotPasswordVerificationCode',
  QR_LOGINSIGNUP_FORGOTPASSWORDRESEND: 'qr_loginSignup_forgotPasswordResend',
  QR_LOGINSIGNUP_FORGOTPASSWORDPASSWORD: 'qr_loginSignup_forgotPasswordPassword',
  QR_LOGINSIGNUP_FORGOTPASSWORDCONFIRMPASSWORD: 'qr_loginSignup_forgotPasswordConfirmPassword',
  QR_LOGINSIGNUP_FORGOTSAVEPASSWORD: 'qr_loginSignup_forgotSavePassword',
  QR_LOGINSIGNUP_SIGNOUT: 'qr_loginsignup_signout',

  // My Account done
  QR_MYACCOUNT_TAPPED: 'qr_myAccount_tapped',
  QR_MYACCOUNT_PERSONALINFO: 'qr_myAccount_personalInfo',
  // QR_MYACCOUNT_PASSWORD: 'qr_myAccount_password',
  // QR_MYACCOUNT_ADDRESS: 'qr_myAccount_address',
  QR_MYACCOUNT_FIRSTNAME: 'qr_myAccount_firstName',
  QR_MYACCOUNT_PERSONALINFOSAVE: 'qr_myAccount_personalInfoSave',
  QR_MYACCOUNT_ADDEMAIL: 'qr_myAccount_addEmail',
  QR_MYACCOUNT_ADDEMAILNEXT: 'qr_myAccount_addEmailNext',
  QR_MYACCOUNT_ADDEMAILCODEFILLED: 'qr_myAccount_addEmailCodeFilled',
  QR_MYACCOUNT_ADDEMAILRESEND: 'qr_myAccount_addEmailResend',
  QR_MYACCOUNT_PERSONALINFOEMAILADDED: 'qr_myAccount_personalInfoEmailAdded',
  QR_MYACCOUNT_PERSONALINFOCHANGESSAVED: 'qr_myAccount_personalInfoChangesSaved',
  // QR_MYACCOUNT_MARKETINGSIGNUP: 'qr_myAccount_marketingSignup',
  // QR_MYACCOUNT_DELETEACCOUNT: 'qr_myAccount_deleteAccount',
  // QR_MYACCOUNT_DELETEACCOUNTCANCEL: 'qr_myAccount_deleteAccountCancel',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP1CANCEL: 'qr_myAccount_deleteAccountStep1Cancel',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP1CONTINUE: 'qr_myAccount_deleteAccountStep1continue',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP2CONTINUE: 'qr_myAccount_deleteAccountStep2continue',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP2CANCEL: 'qr_myAccount_deleteAccountStep2Cancel',
  // QR_MYACCOUNT_DELETEACCOUNTPHONEVERIFYFILLED: 'qr_myAccount_deleteAccountPhoneVerifyFilled',
  // QR_MYACCOUNT_DELETEACCOUNTPHONERESEND: 'qr_myAccount_deleteAccountPhoneResend',
  // QR_MYACCOUNT_DELETEACCOUNTDELETEEMAILVERIFYFILLED: 'qr_myAccount_deleteAccountDeleteEmailVerifyFilled',
  // QR_MYACCOUNT_DELETEACCOUNTDELETEEMAILRESEND: 'qr_myAccount_deleteAccountDeleteEmailResend',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP3CANCEL: 'qr_myAccount_deleteAccountStep3Cancel',
  // QR_MYACCOUNT_DELETEACCOUNTSTEP3DELETE: 'qr_myAccount_deleteAccountStep3Delete',
  // ACCOUNT_DEACTIVATED: 'account_deactivated',

  // Post Ordering done
  QR_POSTORDERING_SEEMORE: 'qr_postOrdering_seeMore',
  QR_POSTORDERING_SEELESS: 'qr_postOrdering_seeLess',
  QR_POSTORDERING_VIEWRECEIPT: 'qr_postOrdering_viewReceipt',
  QR_POSTORDERING_EMAILRECEIPT: 'qr_postOrdering_emailReceipt',
  QR_POSTORDERING_SMSRECEIPT: 'qr_postOrdering_smsReceipt',
  QR_POSTORDERING_SENDRECEIPT: 'qr_postOrdering_sendReceipt',
  QR_POSTORDERING_STAR: 'qr_postOrdering_star',
  QR_POSTORDERING_REVIEWCROSS: 'qr_postOrdering_reviewCross',
  QR_POSTORDERING_ITEMREVIEW: 'qr_postOrdering_itemReview',
  QR_POSTORDERING_ITEMLIKE: 'qr_postOrdering_itemLike',
  QR_POSTORDERING_POSTREVIEW: 'qr_postOrdering_postReview',
  QR_POSTORDERING_DONEREVIEWSUCCESSFUL: 'qr_postOrdering_doneReviewSuccessful',
  QR_POSTORDERING_CROSSREVIEWSUCCESSFUL: 'qr_postOrdering_crossReviewSuccessful',
  QR_POSTORDERING_DONEREVIEWUNSUCCESSFUL: 'qr_postOrdering_doneReviewUnSuccessful',
  QR_POSTORDERING_CROSSREVIEWUNSUCCESSFUL: 'qr_postOrdering_crossReviewUnSuccessful',
  QR_POSTORDERING_VIEW: 'qr_postOrdering_view',

  // loyalty event for QR

  QR_RESTAURANTPAGE_REDEEMNOW: 'qr_restaurantPage_redeemNow',
  QR_CART_REDEEMNOW: 'qr_cart_redeemNow',
  QR_RESTAURANTPAGE_VIEWDETAILS: 'qr_restaurantPage_viewDetails',
  QR_CART_VIEWDETAILS: 'qr_cart_viewDetails',
  QR_REWARDS_LOGIN: 'qr_rewards_login',
  QR_REWARDS_SIGNUP: 'qr_rewards_signUp',
  QR_REWARDS_CARTLOGIN: 'qr_rewards_cartLogin',
  QR_REWARDS_CARTSIGNUP: 'qr_rewards_cartSignUp',
  QR_POSTORDERING_LOGIN: 'qr_postOrdering_login',
  QR_POSTORDERING_SIGNUP: 'qr_postOrdering_signup',

  // DEALS EVENTS QR

  QR_RESTPAGE_DEALSTAPPED: 'qr_restPage_dealsTapped',
  QR_DEALS_UNLOCKDEALS: 'qr_deals_unlockDeals',
};

export const NuggetEventActions = {
  OL_Nugget_Checkout_Payment_Info: 'ol_nugget_checkout_payment_info',
  OL_Nugget_Checkout_Payment_Progress: 'ol_nugget_checkout_payment_progress',
  OL_Nugget_Checkout_Payment_Success: 'ol_nugget_checkout_payment_success',
  OL_Nugget_Checkout_Payment_Failure: 'ol_nugget_checkout_payment_failure',
  OL_Nugget_Checkout_Payment_Retry: 'ol_nugget_checkout_payment_retry',
  OL_Nugget_Checkout_User_Inactive: 'ol_nugget_checkout_user_inactive',
  OL_Nugget_Checkout_User_Activity_Continued: 'ol_nugget_checkout_user_activity_continued',
  OL_Nugget_Checkout_Session_Expire_Warning: 'ol_nugget_checkout_session_expire_warning',
  OL_Nugget_Checkout_Session_Expired: 'ol_nugget_checkout_session_expired',
};
